import { createMasterScreen } from '../../../components/erp/ERPMasterScreenFactory';
export default createMasterScreen({
  title: 'Color Master', screenId: '4.3.8', module: 'Procurement', apiPath: 'color', screenName: 'ColorMaster', idField: 'ColorId', nameField: 'ColorName',
  gridColumns: [{ field: 'ColorId', header: 'Color ID' }, { field: 'ColorName', header: 'Color Name' }],
  formFields: [{ field: 'ColorId', label: 'Color Id', disabled: true }, { field: 'ColorName', label: 'Color Name', required: true }]
});
